
const AnimatedLogo = ({width, height, className}) => {
	return (
		<svg className={"animated-logo " + className} viewBox="0 0 8.4666666 8.4666666" width={width} height={height}>
			<g id="layer1">
				<rect
					className="rect1"
					id="rect234"
					width="7.4475269"
					height="7.4475269"
					x="0.51522887"
					y="0.50945973"
					ry="3.7237635" />
				<rect
					className="rect2"
					id="rect1285"
					width="4.3106275"
					height="4.3106275"
					x="2.0780196"
					y="2.0779362"
					ry="2.1553137" />
			</g>
		</svg>
	)
}

export default AnimatedLogo
